module.exports = __webpack_public_path__ + "static/img/佳能 Canon EOS R6 Mark II.7a6c1aa1.png";